<template>
	<div class="d-flex flex-row align-center justify-space-between">
		<p class="mb-0 caption"><b>Participantes</b></p>

		<v-menu offset-y :close-on-content-click="false">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					dark
					small
					color="#2D4B95"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark small>mdi-eye</v-icon>
				</v-btn>
			</template>
			<v-list dense class="py-0">
				<v-list-item-group color="#5E85EF" class="overflow-y-auto" style="max-height: 300px">
					<v-list-item dense class="mb-0" style="min-height: 25px; background: #5E85EF;">
						<div class="d-flex flex-row align-center justify-space-between" style="width: 100%">
							<p class="caption mb-0 font-weight-bold white--text">Participantes</p>
							<v-btn
								icon
								dark
								x-small
								color="white"
								@click="addParticipantModal = true"
							>
								<v-icon dark>mdi-plus-circle</v-icon>
							</v-btn>
						</div>
					</v-list-item>
					<v-list-item
						v-if="participants.length === 0"
						dense
						class="px-0 py-0"
						style="width:100%"
					>
						<div class="d-flex flex-column align-center justify-center pa-2">
							<v-icon class="my-1">mdi-close-octagon-outline</v-icon>
							<p class="body-2 caption mb-0">No se han agregado participantes aún</p>
						</div>
					</v-list-item>
					<v-list-item
						v-for="(user, index) in participants"
						:key="index"
						dense
						class="px-0 py-0"
						style="width:100%"
					>
						<div style="width:100%">
							<div class="d-flex flex-row align-center justify-space-between px-4 pt-2">
								<div class="d-flex flex-row align-center">
									<img :src="user.basic_info.avatar" class="notification-img"/>
									<div class="px-4">
										<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ user.name }}</p>
										<p class="mb-0 caption" style="color: #707070;">{{ user.email }}</p>
									</div>
								</div>
								<v-btn
									icon
									dark
									x-small
									color="#5E85EF"
									class="ml-2"
									:loading="loadingRemoveParticipant"
									@click="removeParticipant(user)"
								>
									<v-icon dark>mdi-delete-outline</v-icon>
								</v-btn>
							</div>
							<v-divider class="mt-2"></v-divider>
						</div>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
    <AddParticipantModal
			:item="item"
			:addParticipantModal="!!addParticipantModal"
			:closeModal="closeAddParticipantModal"
			:addingToType="3"/>
	</div>
</template>
<script>
import {removeGlobalPaymentStatusParticipant} from '@/helpers/api/additionals'
import AddParticipantModal from '@/components/Globals/Modals/General/AddParticipantModal'
export default {
	name: 'ParticipantsAgps',
	props: {
		participants: {
			type: Array,
			required: true,
		},
		item: {
			type: Object,
			required: true
		}
	},
	components: { AddParticipantModal },
	data: () => ({
		addParticipantModal: false,
		loadingRemoveParticipant: false
	}),
	methods: {
		async removeParticipant(user){
			const data = {
				user_id: user.id,
				additional_global_payment_status_id: this.item.id
			}
			await removeGlobalPaymentStatusParticipant(data)
			this.$store.adicionalesStore.dispatch('getAdditionalInformativeTable',
				{
					project_id: this.item.project_id,
					page: 1
				})
		},
		closeAddParticipantModal(){
			this.addParticipantModal = false
		}
	}
}
</script>

<style scoped>
  .notification-img{
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
</style>